<template>
    <div id="codapay">
        <!-- ------------------------------儲值開始------------------------------ -->
        <section class="cm-depositcenter-deposit-section">
            <div class="container-fluid p-0">
                <div class="row no-gutters">
                    <div class="col">
                        <img class="img-fluid" :src=imageUrl>
                    </div>
                </div>
            </div>

            <div class="d-flex align-items-start justify-content-center mb-4 cm-triangle">
                <img class="img-fluid pt-lg-2 pt-1" style="max-width:15%" :src=imageCodapayLogo>
            </div>

            <form id="deposit">
                <div class="cm-depositcenter-deposit-container">
                    <div v-if="domControl.waitingGameDepositInfo==true"
                         class="d-flex justify-content-center">
                        <div class="spinner-border" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                    
                    <div v-else>
                        <!--選擇遊戲   -->
                        <select class="form-control form-control-lg cm-depositcenter-deposit-select" 
                        name="gameCode" 
                        id="select_gameCode" 
                        @change="setGameSeverGroupOptions($event)" 
                        v-model="selected.gameCode">
                            <option active value="null">{{$t('codapay.select.ChooseGame')}}</option>
                            <option v-for="(game, index) in options.games"
                                    :key="index"
                                    :value="game.gamecode" 
                                    :gamepk="game.pk">
                                        {{game.text}}
                            </option>
                        </select>
                        <br>
    
                        <!--選擇大區-->
                        <select class="form-control form-control-lg cm-depositcenter-deposit-select"
                        id="select_gameServerGroup" 
                        name="gameServerGroup"
                        @change="setGameSeverOptions" 
                        v-model="selected.gameServerGroup"
                        v-show="selected.gameCode!=='null'&&selected.gameCode!==''&&domControl.showGameServerGroup===true"
                        >
                            <option value="null">{{$t('codapay.select.ChooseGameServerGroup')}}</option>
                            <option v-for="(gameServerGroup, index) in options.gameServerGroups"
                                    :key="index"
                                    :value="gameServerGroup.num" 
                                    :serevrgroupid="gameServerGroup.id">
                                        {{gameServerGroup.text}}
                            </option>
                        </select>
                        <br v-show="selected.gameCode!=='null'&&selected.gameCode!==''&&domControl.showGameServerGroup===true">
                        
                        <!-- 選擇伺服器 -->
                        <select class="form-control form-control-lg cm-depositcenter-deposit-select"
                        id="select_gameServerNum" 
                        name="gameServerNum"
                        @change="setGameRoleOptions"
                        v-model="selected.gameServerNum"
                        v-show="selected.gameServerGroup!=='null'&&selected.gameServerGroup!==''"
                        >
                            <option value="null">{{$t('codapay.select.ChooseGameServer')}}</option>
                            <option v-for="(gameServer, index) in options.gameServers"
                                    :key="index"
                                    :value="gameServer.num" 
                                    :serverpk="gameServer.pk">
                                        {{gameServer.text}}
                            </option>
                        </select>
                        <br>
    
                        <!-- 選擇角色 -->
                        <select class="form-control form-control-lg cm-depositcenter-deposit-select"
                        id="select_gameRole" 
                        name="gameRoleId"
                        @change="setCountryOptions($event)"
                        v-model="selected.gameRoleObj"
                        v-show="selected.gameServerNum!=='null'&&selected.gameServerNum!==''"
                        >
                            <option value="null">{{$t('codapay.select.ChooseRole')}}</option>
                            <option v-for="(roleObj, index) in options.roleObjs"
                                    :key="index"
                                    :value="{gameRoleId: roleObj.roleId, gameRoleName: roleObj.roleName}">
                                        {{roleObj.roleName}}
                            </option>
                        </select>
                        <br>
    
                        <!-- 選擇國家 -->
                        <select class="form-control form-control-lg cm-depositcenter-deposit-select"
                        id="select_countries"
                        @change="setChannelOptions"
                        v-model="selected.countryCode"
                        v-show="selected.gameRoleId!=='null'&&selected.gameRoleId!==''&&selected.gameRoleName!=='null'&&selected.gameRoleName!==''"
                        >
                            <option value="null">{{$t('codapay.select.ChooseCountry')}}</option>
                            <option v-for="(country, index) in options.countries"
                                    :key="index"
                                    :value="country.value">
                                        {{country.text}}
                            </option>
                        </select>
                        <br>
    
                        <!-- 選擇付費廠商 -->
                        <select class="form-control form-control-lg cm-depositcenter-deposit-select"
                        id="select_channels"
                        @change="setDepositItemsOptions"
                        v-model="selected.payChannelId"
                        v-show="selected.countryCode!=='null'&&selected.countryCode!==''"
                        >
                            <option value="null">{{$t('codapay.select.ChooseChannel')}}</option>
                            <option v-for="(channel, index) in options.channels"
                                    :key="index"
                                    :value="channel.value">
                                        {{channel.text}}
                            </option>
                        </select>
                        <br>
    
                        <!-- 選擇儲值品項 -->
                        <select class="form-control form-control-lg cm-depositcenter-deposit-select"
                        id="select_depositOptions"
                        @change="dealDepositItem"
                        v-model="selected.depositItemObj"
                        v-show="selected.payChannelId!=='null'&&selected.payChannelId!==''"
                        >
                            <option value="null">{{$t('codapay.select.ChooseDepositItem')}}</option>
                            <option v-for="(depositOption, index) in options.depositOptions"
                                    :key="index"
                                    :value="{depositItemId: depositOption.depositItemId, amount: depositOption.amount, referenceName: depositOption.referenceName}">
                                        {{depositOption.itemNameEn}}
                            </option>
                        </select>
                        <br>
    
                        <!-- 送出訂單按鈕 -->
                        <div class="loginBtnBox"
                        v-show="selected.depositItemAmount!=='null'&&selected.depositItemAmount!==''&&selected.depositItemId!=='null'&&selected.depositItemId!==''"
                        :class="{'d-flex justify-content-center':selected.depositItemAmount!=='null'&&selected.depositItemAmount!==''&&selected.depositItemId!=='null'&&selected.depositItemId!==''}" 
                        >
                            <a id="btn_deposit"
                            href="#"
                            value="iWant"
                            class="cm-depositcenter-deposit-receipt-btn"
                            @click.prevent="clickIWantBtn"
                            v-if="!domControl.showLoading">{{$t('codapay.btn.IWant')}}</a>
                            
                            <div v-else class="spinner-border text-light" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </section>
        <div style="display:none">
            <!-- 會員資料Div -->
            <div id="login" style="display: none;"></div>

            <!-- [B] 建儲值單後金流導向 -->
            <form id="form_depositPost" method="get">
                <input id="depositPostCookie" type="hidden" name="depositPostCookie" value="" />
                <input id="depositPostMemberPk" type="hidden" name="depositPostKey" value="" />
                <input id="depositPostPk" type="hidden" name="depositId" value="" />
                <input id="paymentPlatform" type="hidden" name="paymentPlatform" value="codapay" />
            </form>
            <!-- [E] 建儲值單後金流導向 -->
        </div>
        <!-- ------------------------------儲值結束------------------------------ -->
    </div>
</template>

<script>
import axios from 'axios'
import $ from 'jquery'
import CookieUtil from "@/assets/js/util/CookieUtil.js";
import ShowMsg from "@/assets/js/util/ShowMsg.js";
import router from '@/router.js';
import * as BackendSetting from "@/assets/js/util/BackendSetting.js";
import eventBus from '@/assets/js/event/EventBus.js';

const locale = 5

export default {
    name: "codapay",
    created() {
        this.init(9);
        if(CookieUtil.getCookie(process.env.VUE_APP_COOKIE_FRONTEND_ID_COOKIE)!==false) {
            this.insertActionDOM(); // 遠端取得儲值選項
        }
    },
    mounted() {
        this.updateTopBackgroundImg();

        // 更換語言時
        const self = this;
        if(eventBus["_events"][process.env.VUE_APP_EVENT_EMIT_CHANGE_LANGUAGE_ROUTER_CODAPAY] !== undefined) {
            delete eventBus["_events"][process.env.VUE_APP_EVENT_EMIT_CHANGE_LANGUAGE_ROUTER_CODAPAY]
        }
        eventBus.$on(process.env.VUE_APP_EVENT_EMIT_CHANGE_LANGUAGE_ROUTER_CODAPAY, function(i18n) {
            self.updateTopBackgroundImg(i18n);
            self.init(9);
            
            // url有gameCode參數
            if(self.$route.query.gameCode !== undefined) {
                self.autoSelectFromUrl.isAutoSelect = true
                self.autoSelectFromUrl.gameCode = self.$route.query.gameCode
            }

            self.setInitData()
        });

        eventBus.$emit(process.env.VUE_APP_EVENT_EMIT_SWITCH_PAGE_SHOW_ITEMS , false);

        // 驗證登入所需參數，未登入狀態則顯示loginModal讓玩家登入，玩家登入完畢後再回來
        let verifySetting = {
            verifyStatus: true, // 驗證登入
            from: router.currentRoute.name, // 來源頁面
            setFrontendRouterPushCookie: true, // 是否設置cookie方便登入會導回from設置的頁面
            showLoginModal: true, // 未登入狀態下顯示loginModal
            setCookie: {}
        };

        // 判斷參數
        if(this.$route.query.result != undefined) { // 依照result參數處理訂單的成功失敗
            var showMsgModalText = '';
            if(this.$route.query.result == 'success') { // 儲值成功
                showMsgModalText = this.$i18n.t('codapay.result.DepositSucces') + '<br>【' 
                + this.$i18n.t('codapay.result.DepositCMID') + this.$route.query.id + ', '
                + this.$i18n.t('codapay.result.DepositMoney') + this.$route.query.money + '】';
            }
            else { // 儲值失敗
                showMsgModalText = this.$i18n.t('codapay.result.DepositFail') + '<br>【' + this.$route.query.msg +'】';
            }
            this.setModalText(showMsgModalText,''); // show出儲值訊息
        }
        else if(this.$route.query.gameCode !== undefined // 判斷url或cookie是否有gameCode參數
            || CookieUtil.getCookie(process.env.VUE_APP_COOKIE_CODAPAY_AUTOSELECT_GAMECODE)!==false) {
            if(this.$route.query.gameCode !== undefined) { // url有gameCode參數
                this.autoSelectFromUrl.isAutoSelect = true
                this.autoSelectFromUrl.gameCode = this.$route.query.gameCode
                verifySetting.setCookie[process.env.VUE_APP_COOKIE_CODAPAY_AUTOSELECT_GAMECODE] = this.$route.query.gameCode
            }
            else if(CookieUtil.getCookie(process.env.VUE_APP_COOKIE_CODAPAY_AUTOSELECT_GAMECODE)!==false) {  // cookie有gameCode參數
                this.autoSelectFromUrl.isAutoSelect = true
                this.autoSelectFromUrl.gameCode = CookieUtil.getCookie(process.env.VUE_APP_COOKIE_CODAPAY_AUTOSELECT_GAMECODE)
                CookieUtil.commonDeleteCookie(process.env.VUE_APP_COOKIE_CODAPAY_AUTOSELECT_GAMECODE);
            }
        }
        else if(this.$route.params != undefined && this.$route.params["type"] != undefined) {
            if(this.$route.params["type"] == this.autoSelectFromParams.autoSelectTypeName.autoSelectGameAndGameServerGroupAndGameServer) {
                this.autoSelectGameAndGameServerGroupAndGameServer(this.$route.params)
            }
        }

        eventBus.$emit(process.env.VUE_APP_EVENT_EMIT_VERIFY_LOGIN, verifySetting); // 驗證是否為登入狀態
    },
    data() {
        return {
            asyncTry: null,
            remoteInfo: { // API獲取資訊
                Fk: '', // 主帳號PK
                Pk: '', // 子帳號PK
                AccountCreated: '',
                MmiInfoByGameCode: {}, // 各個gamecode所對應的accountCreated, pk, fk
                codapayPaymentInfo: {}, // codapay的付款國家&付費廠商資訊
                DepositResultJson: ''
            },
            options: { // 提供client的選項
                games: [],
                countries: [],
                gameServerGroups: [],
                gameServers: [],
                roleObjs: [], // [{"roleId": 999, "roleName": "YYY"}]
                channels: [], // 付費廠商
                depositOptions: [], // 儲值選項
            },
            selected: { // 記錄client選擇的值
                gameCode: "null",
                countryCode: "null",
                gameServerGroup: "null",
                gameServerNum: "null",
                roleId: "null",
                payChannelId: "null",
                gameRoleObj: "null", // object, ex:{"gameRoleId": 999, "gameRoleName": "YYY"}
                gameRoleId: "null",
                gameRoleName: "null",
                cashflowSupplierId: "null",
                cashflowSupplierStatus: "null",
                cashflowSupplierAlertMessage: "null",
                depositItemObj: "null", // object, ex:{"depositItemId":1,"amount":990000,"referenceName":"JJ.ID.Coda02.0.99"}
                depositItemAmount: "null",
                depositItemId: "null",
            },
            domControl: {
                showGameServerGroup: true,
                showLoading: false,
                waitingGameDepositInfo: true,
            },
            autoSelectFromUrl: {
                isAutoSelect: false,
                gameCode: null,
            },
            autoSelectFromParams: {
                isAutoSelect: false,
                autoSelectType: null,
                gameCode: null,
                serverGroupId: null,
                gameServerNum: null,
                gameRoleId: null,
                gameRoleName: null,
                autoSelectTypeName: {
                    autoSelectGameAndGameServerGroupAndGameServer: "autoSelectGameAndGameServerGroupAndGameServer"
                }
            },
            imageUrlDefault: require("@/assets/images/game/gametitle.jpg"),
            imageUrl: require("@/assets/images/game/gametitle.jpg"),
            imageCodapayLogo: require("@/assets/images/logo/codapay/codapay-smokegrey.png"),
        }
    },
    methods: {
        async updateTopBackgroundImg(i18n = this.$i18n) {
            // 更新上方背景圖
            let imageUrl = await BackendSetting.getTopBackgroundImgUrl(i18n.locale);
            this.imageUrl = (imageUrl != "" ? imageUrl : this.imageUrlDefault);
        },
        init(num)
        {
            if(num>8) {
                this.options.games = [];
                this.selected.gameCode = "null";
            }
            if(num>7) {
                this.options.gameServerGroups = [];
                this.selected.gameServerGroup = "null";
            }
            if(num>6) {
                this.options.gameServers = [];
                this.selected.gameServerNum = "null";
            }
            if(num>5) {
                this.options.roleObjs = [];
                this.selected.gameRoleObj = "null";
            }
            if(num>4) {
                this.options.countries = [];
                this.selected.gameRoleId="null";
                this.selected.gameRoleName="null";
                this.selected.countryCode="null";
                this.selected.cashflowSupplierId="null";
                this.selected.cashflowSupplierStatus="null";
                this.selected.cashflowSupplierAlertMessage="null";
                this.remoteInfo.codapayPaymentInfo = {}
            }
            if(num>3) {
                this.options.channels = [];
                this.selected.payChannelId = "null";
            }
            if(num>2) {
                this.options.depositOptions = [];
                this.selected.depositItemObj="null"
            }
            this.selected.depositItemAmount="null"
            this.selected.depositItemId="null"
        },
        initAutoSelectFromUrl(num) {
            if(num >= 100) {
                this.autoSelectFromUrl.isAutoSelect = false
            }
            if(num >= 1) {
                this.autoSelectFromUrl.gameCode = null
            }
        },
        initAutoSelectFromParams(num) {
            if(num >= 100) {
                this.autoSelectFromParams.isAutoSelect = false
            }
            if(num >= 30) {
                this.autoSelectFromParams.autoSelectType = null
                this.autoSelectFromParams.gameCode = null
                this.autoSelectFromParams.serverGroupId = null
                this.autoSelectFromParams.gameServerNum = null
                this.autoSelectFromParams.gameRoleId = null
                this.autoSelectFromParams.gameRoleName = null
            }
        },
        // 遠端取得儲值選項
        async insertActionDOM() { //為了繞過CORS問題
            if(document.querySelectorAll("head script[src='" + 
            process.env.VUE_APP_URL_DOMAIN_LOGIN + "/initMdepositJsonAction.shtml?paymentStatus=3" +
            "']").length <= 0)
            {
                let redirectDepositPage = document.createElement("script");
                redirectDepositPage.setAttribute("src", process.env.VUE_APP_URL_DOMAIN_LOGIN + "/initMdepositJsonAction.shtml?paymentStatus=3");
                document.head.appendChild(redirectDepositPage);
            }
            await this.checkInitData();
        },
        // 確認遠端取得儲值選項是否成功
        checkInitData()
        {
            let self = this;
            let count = 0;
            let waitSecond = 1000;
            let limitN = process.env.VUE_APP_AJAX_TIME_OUT_MILLISECOND / waitSecond;
            this.asyncTry = setInterval(function(){
                try {
                    if(remoteDepositInfo) {
                        self.setInitData();
                    }
                }
                catch(e) {}
                if(count >= limitN )
                {
                    clearInterval(self.asyncTry);
                    alert(self.$i18n.t('common.Backend.Response.ConnectionFailed'));
                    return;
                }
                count ++;
            },waitSecond);
        },
        // 初始化儲值選項
        async setInitData()
        {
            try{
                clearInterval(this.asyncTry);
                this.domControl.waitingGameDepositInfo = false
                this.DepositResultJson = JSON.parse(remoteDepositInfo.getDeposit());

                // 將不允許儲值codapay的遊戲資訊刪除
                const gameCodeList = Object.keys(this.DepositResultJson)
                for(let i=0; i<gameCodeList.length; i++) {
                    const gameCode = gameCodeList[i]
                    // 不允許儲值codapay的遊戲就依照gamecode刪除
                    if(!process.env.VUE_APP_DEPOSIT_CODAPAY_ALLOW_GAMECODE_LIST.split(',').includes(gameCode)) {
                        delete this.DepositResultJson[gameCode];
                    }
                }
                
                // 從API取得玩家相關資訊
                this.remoteInfo.Fk = JSON.parse(remoteDepositInfo.getFk());
                this.remoteInfo.Pk = JSON.parse(remoteDepositInfo.getPk());
                this.remoteInfo.AccountCreated = remoteDepositInfo.getAccountCreated();
                this.remoteInfo.MmiInfoByGameCode = remoteDepositInfo.getMmiInfoJson();
                
                if(this.DepositResultJson === '') {
                    alert(this.$i18n.t('common.PleaseLogin'));
                    router.push({name: process.env.VUE_APP_ROUTER_HOME});
                }
                else {
                    this.setGamesOptions();
                }
            }
            catch(err) {
                console.log(err);
                alert(this.$i18n.t('common.PleaseLogin'));
                router.push({name: process.env.VUE_APP_ROUTER_HOME});
            }
        },
        // modal顯示訊息
        setModalText(content, url)
        {
            $('#showMsgModalText').html(content);
            $("#showMsgModalText").css("text-align","center");
            //防止按下esc或頁面外時，modal消失的狀況
            $('#showMsgModal').modal({
                keyboard: false,
                backdrop: false
            });
            if(url.length > 0)
            { $('#MsgButton').attr('onclick',"window.location.href='"+url+"'"); }
            $('#showMsgModal').modal('show');
        },
        // 設置遊戲選項
        setGamesOptions() {            
            this.init(9);
            for(var gamecodeStr in this.DepositResultJson) {
                const gameObj = this.DepositResultJson[gamecodeStr]
                this.options.games.push({
                    gamecode: gamecodeStr,
                    pk: gameObj['gamePk'],
                    text: gameObj['gameName']
                });
            }

            // 自動代入遊戲選項
            let callSetGameSeverGroupOptions = false
            if((this.autoSelectFromParams.isAutoSelect==true && this.autoSelectFromParams.gameCode!=null)
               || (this.autoSelectFromUrl.isAutoSelect==true && this.autoSelectFromUrl.gameCode!=null))
            {
                // 若需要自動代入gameCode，先取出gameCode
                let autoSelectGameCode = false
                if(this.autoSelectFromParams.isAutoSelect==true && this.autoSelectFromParams.gameCode!=null)
                    autoSelectGameCode = this.autoSelectFromParams.gameCode
                else if(this.autoSelectFromUrl.isAutoSelect==true && this.autoSelectFromUrl.gameCode!=null)
                    autoSelectGameCode = this.autoSelectFromUrl.gameCode

                // 若自動代入的gameCode存在，執行自動帶入
                if(autoSelectGameCode != false) {
                    // 判斷自動代入的gameCode是否存在於遊戲選項中
                    let isAutoSelectGameCodeExist = false
                    for(let i=0; i<this.options.games.length; i++) {
                        const game = this.options.games[i]
                        if(game.gamecode == autoSelectGameCode) {
                            isAutoSelectGameCodeExist = true
                            break
                        }
                    }

                    // 確認gameCode存在，執行自動代入
                    if(isAutoSelectGameCodeExist) {
                        // autoSelectFromUrl目前只有自動代入gameCode，固可以先初始化
                        if(this.autoSelectFromUrl.isAutoSelect==true && this.autoSelectFromUrl.gameCode!=null) {
                            this.initAutoSelectFromUrl(100)
                        }
                        // 代入gameCode，自動執行下一步
                        this.selected.gameCode = autoSelectGameCode
                        callSetGameSeverGroupOptions = true
                    }
                    else { // gameCode不存在，初始化所有資料
                        this.initAutoSelectFromUrl(100)
                        this.initAutoSelectFromParams(100)
                    }
                }
            }

            // 自動執行下一步
            if(callSetGameSeverGroupOptions) {
                this.setGameSeverGroupOptions();
            }
        },
        // 設置伺服器分區選項
        setGameSeverGroupOptions() {
            this.init(8);
            let callSetGameSeverOptions = false;
            if(this.selected.gameCode !== 'null' && this.selected.gameCode !== '') {
                for(var serverGroupId in this.DepositResultJson[this.selected.gameCode]['serverGroups']) {  
                    const serverGroupObj = this.DepositResultJson[this.selected.gameCode]['serverGroups'][serverGroupId]
                    // 將膽英文不給網頁儲值(留著供參照)
                    if(this.selected.gameCode == 'jiangdan' && serverGroupId == 1) {
                        continue;
                    }
                    else {
                        this.options.gameServerGroups.push({
                            num: serverGroupId,
                            id: serverGroupObj['serverGroupId'],
                            text: serverGroupObj['serverGroupName']
                        });
                    }
                }
                
                // 伺服器分區只有一個選項，則(1)不顯示且自動記下gameServerGroup、(2)自動call setGameSeverOptions
                if(this.options.gameServerGroups.length==1) {
                    this.selected.gameServerGroup = this.options.gameServerGroups[0].num;
                    this.domControl.showGameServerGroup = false;
                    callSetGameSeverOptions = true;
                }
                else {
                    this.domControl.showGameServerGroup = true;
                }
                
                
                // 自動代入伺服器分區
                if(callSetGameSeverOptions==false
                   && this.autoSelectFromParams.isAutoSelect==true
                   && this.autoSelectFromParams.serverGroupId!=null)
                {
                    // 取得要自動代入的serverGroupId
                    let autoSelectServerGroupId = this.autoSelectFromParams.serverGroupId

                    // 判斷要自動代入的serverGroupId是否存在
                    let isAutoSelectServerGroupIdExist = false
                    for(let i in this.options.gameServerGroups) {
                        let serverGroupObj = this.options.gameServerGroups[i]
                        if(serverGroupObj["num"] == autoSelectServerGroupId) {
                            isAutoSelectServerGroupIdExist = true
                            this.selected.gameServerGroup = this.options.gameServerGroups[0].num
                            break
                        }
                    }
                    
                    // 要代入的serverGroupId存在，要自動執行下一步，反之則清除autoSelect資料
                    if(isAutoSelectServerGroupIdExist)
                        callSetGameSeverOptions = true
                    else
                        this.initAutoSelectFromParams(100)
                }

                // 自動執行下一步
                if(callSetGameSeverOptions) {
                    this.setGameSeverOptions();
                }
            }
        },
        // 設置遊戲伺服器選項
        setGameSeverOptions()
        {
            this.init(7);
            if(this.selected.gameServerGroup !== 'null' && this.selected.gameServerGroup !== '') {
                // 取得遊戲伺服器列表
                const gameServerList = this.DepositResultJson[this.selected.gameCode]['serverGroups'][this.selected.gameServerGroup]['server']
                // 將每個遊戲伺服器資訊塞到選項中
                for(let i=0; i<gameServerList.length; i++) {
                    const gameServerObj = gameServerList[i]
                    this.options.gameServers.push({
                        num: gameServerObj['gameServerNum'],
                        pk: gameServerObj['serverPk'],
                        text: gameServerObj['gameServerName']
                    });
                }


                // 自動代入遊戲伺服器
                let callSetGameRoleOptions = false
                if(this.autoSelectFromParams.isAutoSelect==true && this.autoSelectFromParams.gameServerNum!=null) {
                    // 取得要自動代入的gameServerNum
                    let autoSelectGameServerNum = this.autoSelectFromParams.gameServerNum

                    // 判斷要自動代入的gameServerNum是否存在
                    let isAutoSelectGameServerNumExist = false
                    for(let i in this.options.gameServers) {
                        let serverObj = this.options.gameServers[i]
                        if(serverObj["num"] == autoSelectGameServerNum) {
                            isAutoSelectGameServerNumExist = true
                            this.selected.gameServerNum = serverObj["num"]
                            break
                        }
                    }
                    
                    // 要代入的gameServerNum存在，要自動執行下一步，反之則清除autoSelect資料
                    if(isAutoSelectGameServerNumExist)
                        callSetGameRoleOptions = true
                    else
                        this.initAutoSelectFromParams(100)
                }

                // 自動執行下一步
                if(callSetGameRoleOptions) {
                    this.setGameRoleOptions();
                }
            }
        },
        // 設置角色選項
        async setGameRoleOptions()
        {
            this.init(6);
            if(this.remoteInfo.MmiInfoByGameCode[this.selected.gameCode]==undefined) {
                // 依照gamecode找不到對應的遊戲資訊
                alert(this.$i18n.t('codapay.error.NotFountRole'));
            }
            else if(this.selected.gameServerNum !== 'null' && this.selected.gameServerNum !== '') {
                let self = this;
                let bodyFormData = new FormData();
                bodyFormData.append("gameCode", this.selected.gameCode);
                bodyFormData.append("memberMultiIdPk", this.remoteInfo.MmiInfoByGameCode[this.selected.gameCode].pk);
                bodyFormData.append("gameAccountGenerated", this.remoteInfo.MmiInfoByGameCode[this.selected.gameCode].accountCreated);
                bodyFormData.append("gameServerNum", this.selected.gameServerNum);

                // 取得特定遊戲&伺服器中的所有角色資訊
                await axios({
                    method: "post",
                    url: process.env.VUE_APP_URL_DOMAIN_LOGIN + "/getMobileGameRoleInfoAction.shtml",
                    data:bodyFormData,
                    timeout: process.env.VUE_APP_AJAX_TIME_OUT_MILLISECOND,
                    config: { headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }}
                })
                .then(function(response) {
                    if(response.data.result === "success") {
                        const roleList = response.data.msg;
                        for(let i=0; i<roleList.length; i++) { 
                            const roleObj = roleList[i]
                            self.options.roleObjs.push({
                                roleId: roleObj['account'],
                                roleName: roleObj['name']
                            });      
                        }
                    }
                    else {
                        alert(self.$i18n.t('codapay.error.NotFountRole'));
                    }
                })
                .catch(function () {
                    alert(self.$i18n.t('common.Backend.Response.ConnectionFailed'));
                });


                // 自動代入角色選項
                let callSetCountryOptions = false
                if(this.autoSelectFromParams.isAutoSelect==true
                   && this.autoSelectFromParams.gameRoleId!=null
                   && this.autoSelectFromParams.gameRoleName!=null
                   )
                {
                    // 取得要自動代入的gameRoleId和gameRoleName
                    let autoSelectGameRoleId = this.autoSelectFromParams.gameRoleId
                    let autoSelectGameRoleName = this.autoSelectFromParams.gameRoleName

                    // 判斷要自動代入的gameRoleId和gameRoleName是否存在
                    let isAutoSelectGameRoleExist = false
                    for(let i in this.options.roleObjs) {
                        let roleObj = this.options.roleObjs[i]
                        if(roleObj["roleId"]==autoSelectGameRoleId && roleObj["roleName"]==autoSelectGameRoleName) {
                            isAutoSelectGameRoleExist = true
                            this.selected.gameRoleObj = {
                                gameRoleId: roleObj["roleId"],
                                gameRoleName: roleObj["roleName"]
                            }
                            break
                        }
                    }
                    
                    // 要代入的gameRoleId和gameRoleName存在，要自動執行下一步，反之則清除autoSelect資料
                    if(isAutoSelectGameRoleExist) {
                        callSetCountryOptions = true
                        if(this.autoSelectFromParams.autoSelectType == this.autoSelectFromParams.autoSelectTypeName.autoSelectGameAndGameServerGroupAndGameServer) {
                            this.initAutoSelectFromParams(100)
                            console.log('完成任務');
                        }
                    }
                    else
                        this.initAutoSelectFromParams(100)
                }

                // 自動執行下一步
                if(callSetCountryOptions) {
                    this.setCountryOptions();
                }
            }
        },
        // 設置國家選項
        async setCountryOptions(event)
        {
            this.init(5);
            if(this.selected.gameRoleObj!=='null' && this.selected.gameRoleObj!=='') {
                this.selected.gameRoleId = this.selected.gameRoleObj["gameRoleId"]
                this.selected.gameRoleName = this.selected.gameRoleObj["gameRoleName"]

                // 取得codapay的付款國家&付費廠商
                this.remoteInfo.codapayPaymentInfo = await this.ajaxGetFrontEndPayMethodSetAction();

                if(this.remoteInfo.codapayPaymentInfo==null) { // 連線失敗
                    alert(this.$i18n.t('common.Backend.Response.ConnectionFailed'));
                }
                else if(Object.keys(this.remoteInfo.codapayPaymentInfo).length == 0) { // 該遊戲未支援codapay付款
                    alert(this.$i18n.t('codapay.error.DepositNotSupport'))
                }
                else {
                    this.selected.cashflowSupplierId = this.remoteInfo.codapayPaymentInfo["cashflowSupplierId"]
                    this.selected.cashflowSupplierStatus = this.remoteInfo.codapayPaymentInfo["cashflowSupplierStatus"]
                    this.selected.cashflowSupplierAlertMessage = this.remoteInfo.codapayPaymentInfo["cashflowSupplierAlertMessage"]
                    const countries = this.remoteInfo.codapayPaymentInfo["codapayPaymentMethods"]
                    const countriesKeySort = Object.keys(countries).sort()

                    for(let i=0; i<countriesKeySort.length; i++) {
                        const countriesKey = countriesKeySort[i]
                        const countryObj = countries[countriesKey]
                        if(Object.keys(countryObj["payChannelIds"]).length > 0) { // 有開放付費廠商的國家才需要放入國家選項
                            this.options.countries.push({
                                value: countryObj.countryCode,
                                text: countryObj.countryName
                            })
                        }
                    }
                }
            }            
        },
        // 設定付費廠商
        setChannelOptions() {
            this.init(4)
            if(this.selected.countryCode!=='null' && this.selected.countryCode!=='') {
                const payChannelIds = this.remoteInfo.codapayPaymentInfo["codapayPaymentMethods"][this.selected.countryCode]['payChannelIds']
                const payChannelIdList = Object.keys(payChannelIds)
                const payChannelNameObj = {}
                for(let i=0; i<payChannelIdList.length; i++) {
                    const id = payChannelIdList[i]
                    payChannelNameObj[payChannelIds[id]["payChannelName"]] = id
                }
                // 將payChannelName進行sort，之後顯示才會有排序
                const payChannelNameList = Object.keys(payChannelNameObj).sort()
                for(let i=0; i<payChannelNameList.length; i++) {
                    const payChannelName = payChannelNameList[i]
                    const payChannelId = payChannelNameObj[payChannelName]
                    const channelObj = payChannelIds[payChannelId]
                    this.options.channels.push({
                        value: channelObj.payChannelId,
                        text: channelObj.payChannelName
                    })
                }
            }
        },
        // 設定儲值品項
        async setDepositItemsOptions() {
            this.init(3);
            if(this.selected.payChannelId!=='null' && this.selected.payChannelId!=='') {
                const codapayDepositOptionsResult = await this.ajaxGetCodapayDepositOptions(this.selected.payChannelId);
                
                if(codapayDepositOptionsResult!==null
                    && codapayDepositOptionsResult["result"]=="success"
                    && codapayDepositOptionsResult["codapayDepositOptions"]!==undefined
                    && Array.isArray(codapayDepositOptionsResult["codapayDepositOptions"])) {
                    const codapayDepositOptions = codapayDepositOptionsResult["codapayDepositOptions"]
                    for(let i=0; i<codapayDepositOptions.length; i++) {
                        const codapayDepositItemObj = codapayDepositOptions[i]
                        const depostiItem = {
                            "amount": codapayDepositItemObj["itemAmount"],
                            "itemNameEn": codapayDepositItemObj["itemNameEn"],
                            "depositItemId": codapayDepositItemObj["num"],
                            "referenceName": codapayDepositItemObj["itemPid"]
                        }
                        // 若有幣別字母代碼，則使用
                        if(codapayDepositItemObj["currencyCode"]!=null || codapayDepositItemObj["currencyCode"]!="") {
                            depostiItem["itemNameEn"] = `${codapayDepositItemObj["currencyCode"]} ${codapayDepositItemObj["amount"]/100} - ${codapayDepositItemObj["itemNameEn"]}`
                        }
                        this.options.depositOptions.push(depostiItem)
                    }
                }
            }
        },
        // 將儲值品項拆出id與amount
        dealDepositItem() {
            this.init(2)
            if(this.selected.depositItemObj !== 'null' && this.selected.depositItemObj !== '') {
                this.selected.depositItemAmount = this.selected.depositItemObj["amount"]
                this.selected.depositItemId = this.selected.depositItemObj["depositItemId"]
            }
        },
        // 點擊儲值按鈕
        async clickIWantBtn() {
            // 檢查金流是否維修
            if(this.selected.cashflowSupplierStatus == 'MAINTAIN') {
                alert(this.$i18n.t(this.selected.cashflowSupplierAlertMessage));
                return
            }

            // 檢查品項id、品項金額、金流商id
            if ("" == this.selected.depositItemId || "null" == this.selected.depositItemId
                || "" == this.selected.depositItemAmount || "null" == this.selected.depositItemAmount
                || "" == this.selected.cashflowSupplierId || "null" == this.selected.cashflowSupplierId) {
                
                alert(this.$i18n.t('codapay.error.PlzEnterFullInfo'));
                return;
            }

            // 檢查遊戲所對應的子帳號資訊
            if(this.remoteInfo.MmiInfoByGameCode[this.selected.gameCode]==undefined) {
                alert(this.$i18n.t('codapay.error.NotFountRole'));
                return;
            }

            let mmiByGameCode = this.remoteInfo.MmiInfoByGameCode[this.selected.gameCode]
            let bodyFormData = new FormData();
            bodyFormData.append('deposit.memberId', mmiByGameCode.fk);
            bodyFormData.append('deposit.fkMemberMultiId', mmiByGameCode.pk);
            bodyFormData.append('deposit.fkDepositItemId', this.selected.depositItemId);
            bodyFormData.append('deposit.amount', this.selected.depositItemAmount);
            bodyFormData.append('deposit.cashFlowSupplierId', this.selected.cashflowSupplierId);
            bodyFormData.append('gameCode', this.selected.gameCode);
            bodyFormData.append('gameRoleName', this.selected.gameRoleName);
            bodyFormData.append('gameRoleId', this.selected.gameRoleId);
            bodyFormData.append('gameServerGroup', this.selected.gameServerGroup);
            bodyFormData.append('gameServerNum', this.selected.gameServerNum);
            bodyFormData.append('cookieValue', CookieUtil.getCookie(process.env.VUE_APP_COOKIE_FRONTEND_ID_COOKIE));
            bodyFormData.append("invoice.invoiceType", ""); // 沒有發票資訊，傳空字串

            // 建立儲值單
            this.domControl.showLoading = true;
            let self = this;
            const response = await axios({
                method: "post",
                url: process.env.VUE_APP_URL_DOMAIN_LOGIN + "/CookieStringmdepositAction.shtml",
                data: bodyFormData,
                config: { headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }}
            })
            .catch(function(error) {
                var showMsgModalText = self.$i18n.t('codapay.error.FormSubmitFail');
                self.setModalText(showMsgModalText,'');
                self.domControl.showLoading = false;
            });

            if(response!=undefined && response.data!=undefined) {
                var data = response.data;
                if (data.result) {
                    let isSetCookieComplete = await self.ajaxSetGametaiwanCookie(data.msg);
                    if(isSetCookieComplete) {
                        self.goDepositPost(data, mmiByGameCode.fk);
                        return;
                    }
                    else {
                        this.showLoading = false;
                        showMsgModalText = self.$i18n.t('codapay.error.SetGametaiwanCookie');
                        self.setModalText(showMsgModalText,'/');
                        return;
                    }
                }
                else {
                    this.domControl.showLoading = false;
                    var showMsgModalText = '';
                    if ('loginStatusError' == data.msg) {
                        showMsgModalText = self.$i18n.t('common.PleaseLogin');
                        self.setModalText(showMsgModalText,'/');
                    }
                    else if ('forbidDeposit' == data.msg) {
                        showMsgModalText = self.$i18n.t('codapay.error.AccountCantDeposit');
                        self.setModalText(showMsgModalText,'/#/contactus?category=depositQA');
                    }
                    else if ('gameRoleInfoNotFound' == data.msg) {
                        showMsgModalText = self.$i18n.t('codapay.error.NotFountRole');
                        self.setModalText(showMsgModalText,'');
                    }
                    else if ('oneKeyMember' == data.msg) {
                        showMsgModalText = self.$i18n.t('codapay.error.PlzBindAccount');
                        self.setModalText(showMsgModalText,'/');
                    }
                    else {
                        showMsgModalText = self.$i18n.t('codapay.error.ServerBusyNow');
                        self.setModalText(showMsgModalText,'');
                    }
                }
            }
        },
        autoSelectGameAndGameServerGroupAndGameServer(routeParams) {
            if(routeParams["gameCode"] != undefined
               && routeParams["serverGroupId"] != undefined
               && routeParams["gameServerNum"] != undefined
               && routeParams["gameRoleId"] != undefined
               && routeParams["gameRoleName"] != undefined)
            {
                this.autoSelectFromParams.autoSelectType = this.autoSelectFromParams.autoSelectTypeName.autoSelectGameAndGameServerGroupAndGameServer
                this.autoSelectFromParams.gameCode = routeParams["gameCode"]
                this.autoSelectFromParams.serverGroupId = routeParams["serverGroupId"]
                this.autoSelectFromParams.gameServerNum = routeParams["gameServerNum"]
                this.autoSelectFromParams.gameRoleId = routeParams["gameRoleId"]
                this.autoSelectFromParams.gameRoleName = routeParams["gameRoleName"]
                this.autoSelectFromParams.isAutoSelect = true
            }
        },
        // ajax取得codapay付款資訊
        async ajaxGetFrontEndPayMethodSetAction() {
            let countries = null

            let self = this;
            let bodyFormData = new FormData();
            bodyFormData.append("gameCode", this.selected.gameCode);
            bodyFormData.append("locale", locale);
            bodyFormData.append("paymentPlatform", "codapay");
            await axios({
                method: "post",
                url: process.env.VUE_APP_URL_DOMAIN_LOGIN + "/getFrontEndPayMethodSetAction.shtml",
                data:bodyFormData,
                timeout: process.env.VUE_APP_AJAX_TIME_OUT_MILLISECOND,
                config: { headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }}
            })
            .then(function(response) {
                countries = response.data
            })
            .catch(function (e) {
                console.log(e);
            });
            return countries
        },
        // AJAX取得儲值品項
        async ajaxGetCodapayDepositOptions(payChannelId) {
            let self = this;
            let codapayDepositOptions = null
            let bodyFormData = new FormData();
            bodyFormData.append("gameCode", this.selected.gameCode);
            bodyFormData.append("cashflowSupplierId", this.selected.cashflowSupplierId);
            bodyFormData.append("countryCode", this.selected.countryCode);
            bodyFormData.append("payChannelId", this.selected.payChannelId);
            bodyFormData.append("locale", locale);
            await axios({
                method: "post",
                url: process.env.VUE_APP_URL_DOMAIN_LOGIN + "/getCodapayDepositOptionAction.shtml",
                data:bodyFormData,
                timeout: process.env.VUE_APP_AJAX_TIME_OUT_MILLISECOND,
                config: { headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }}
            })
            .then(function(response) {
                codapayDepositOptions = response.data
            })
            .catch(function () {
                alert(self.$i18n.t('common.Backend.Response.ConnectionFailed'));
            });
            return codapayDepositOptions
        },
        async ajaxSetGametaiwanCookie(depositId) { // 透過Ajax在gametaiwan.com設置cookie
            let isSuccess = false;
            let bodyFormData = new FormData();
            bodyFormData.append("depositCookie", CookieUtil.getCookie(process.env.VUE_APP_COOKIE_FRONTEND_ID_COOKIE));
            bodyFormData.append("depositAccountNum", this.remoteInfo.Pk);
            bodyFormData.append("depositId", depositId);
            bodyFormData.append("depositFrom", location.protocol + "//" + location.host);
            
            const response = await axios({
                method: "post",
                timeout: process.env.VUE_APP_AJAX_TIME_OUT_MILLISECOND,
                url: process.env.VUE_APP_URL_DOMAIN_LOGIN_GAMETAIWAN + "/all9FunDeposit.shtml",
                data: bodyFormData,
                withCredentials: true,
                config: { headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }} }
            )
            .catch(function(response) {
                //...
            });

            if(response!=undefined && response.data.result != undefined && response.data.result=="success") {
                isSuccess = true;
            }

            return isSuccess;
        },
        goDepositPost(paramData, memberPk)
        {
            var myData = paramData;
            $("#depositPostPk").val(myData.msg);
            $("#depositPostCookie").val(CookieUtil.getCookie(process.env.VUE_APP_COOKIE_FRONTEND_ID_COOKIE));
            $("#depositPostMemberPk").val(memberPk);
            $("#form_depositPost").attr("action", process.env.VUE_APP_URL_DOMAIN_LOGIN + "/mobileDepositPostAction.shtml");
            $("#form_depositPost").submit();
        },
    },
};

</script>